import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getMatchDetailsSoccerAPI,
  getMatchDetailsTennisAPI,
  getSoccerEventDetailsAPI,
  getSoccerOddsByMatchIdAPI,
  placeSoccerBetAPI,
} from "../service/soccer&tennis";
import { casinoPL } from "../utils/profitLoss";
import { getProfit } from "../utils/constants";
import toast from "react-hot-toast";
import Modal from "../components/Modal";
import BetSlip from "../components/BetSlip";
import moment from "moment";
import { getCricketEventDetailsAPI } from "../service/cricket";
import Loader from "../components/Loader";
import CustomScoreCard from "../components/CustomScoreCard";

export default function SoccerBet() {
  const { id } = useParams();
  const [odds, setOddQuery] = useState({});
  const [game, setGame] = useState("soccer");
  const [loading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const dispatch = useDispatch();
  const [exposure, setExposure] = React.useState({});
  const [eventExposureAndSettings, setEventExposureAndSettings] =
    React.useState();
  const [gameEvent, setGameEvent] = React.useState({});
  const [showScore, setShowScore] = React.useState(true);
  const [modalContent, setModalContent] = React.useState(null);
  const [selectedMarket, setSelectedMarket] = React.useState("All");
  const selectedEventForBet = useSelector(
    (state) => state.gameData.selectedEventForBet
  );

  const [showTv, setShowTv] = React.useState(false);
  const getEventExposureAndSettings = async () => {
    if (userData?.token) {
      const { response, code } = await getMatchDetailsSoccerAPI(id);
      if (code === 200) {
        setEventExposureAndSettings(response);
      }
    }
  };
  const getOdds = async () => {
    const { response, code } = await getSoccerOddsByMatchIdAPI(id);
    if (code == 200) {
      setOddQuery(response);
    }
  };
  var gameSettings = useSelector((state) => state.gameData["soccerSettings"]);
  if (gameSettings && gameSettings[id]) {
    gameSettings = gameSettings[id];
  }
  const getGameEventDetails = useCallback(async () => {
    const { response, code } = await getSoccerEventDetailsAPI(id);
    if (code === 200) {
      setGameEvent(response);
    }
  }, [id]);
  const applyBlinkEffect = (element, type) => {
    element.classList.add("Spark" + type);
    setTimeout(() => {
      element.classList.remove("Spark" + type);
    }, 1000);
  };
  useEffect(() => {
    setSelectedEventForBet(null);
  }, [id]);
  useEffect(() => {
    const observers = [];

    const intervalId = setInterval(() => {
      const layButtons = document.querySelectorAll(".match-book-inner-data");
      if (layButtons.length > 0) {
        clearInterval(intervalId);
        layButtons.forEach((layButton) => {
          const observer = new MutationObserver(() => {
            applyBlinkEffect(layButton.parentElement, "Back");
          });
          observer.observe(layButton, {
            childList: true,
            subtree: true,
            characterData: true,
          });

          observers.push(observer);
        });
      }
    }, 1000); // Check every 1 second

    return () => {
      // Cleanup: clear interval and disconnect observers
      clearInterval(intervalId);
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);
  const handleCashoutClick = (
    marketIdExternal,
    marketType = "matchOdds",
    sports = "soccer"
  ) => {
    const plExposures = [];

    for (
      let i = 0;
      i < eventExposureAndSettings?.plExposureResponseDTOs.length;
      i++
    ) {
      if (
        eventExposureAndSettings?.plExposureResponseDTOs[i].marketIdExternal ===
        marketIdExternal
      ) {
        for (
          let j = 0;
          j <
          eventExposureAndSettings?.plExposureResponseDTOs[i]
            .runnerPlExposureDTOS.length;
          j++
        ) {
          plExposures.push(
            eventExposureAndSettings?.plExposureResponseDTOs[i]
              .runnerPlExposureDTOS[j]
          );
        }
      }
    }

    plExposures.sort((a, b) => b.exposure - a.exposure);

    var odds_ = [];
    let marketData;
    if (sports == "soccer") {
      marketData =
        marketType == "matchOdds"
          ? odds?.matchOddsResponseDTO[0]
          : odds?.other_market_odds?.find(
              (i) => i?.marketId == marketIdExternal
            );
      for (let i = 0; i < marketData.oddDetailsDTOS.length; i++) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId == marketData.oddDetailsDTOS[i].selectionId
          )
        ) {
          odds_.push({
            ...marketData.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId == marketData.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    } else {
      for (let i = 0; i < marketData.oddDetailsDTOS.length; i++) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId == marketData.oddDetailsDTOS[i].selectionId
          )
        ) {
          odds_.push({
            ...marketData.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId == marketData.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    }
    odds_.sort((a, b) => b.exposure - a.exposure);
    var oppositeTeam = {
      back1: parseFloat(odds_[1]?.back1),
      back2: parseFloat(odds_[1]?.back2),
      back3: parseFloat(odds_[1]?.back3),
      backSize1: parseFloat(odds_[1]?.backSize1),
      backSize2: parseFloat(odds_[1]?.backSize2),
      backSize3: parseFloat(odds_[1]?.backSize3),
      lay1: parseFloat(odds_[1]?.lay1),
      lay2: parseFloat(odds_[1]?.lay2),
      lay3: parseFloat(odds_[1]?.lay3),
      laySize1: parseFloat(odds_[1]?.laySize1),
      laySize2: parseFloat(odds_[1]?.laySize2),
      laySize3: parseFloat(odds_[1]?.laySize3),
      exposure: odds_[1]?.exposure,
      runnerName: odds_[1]?.runnerName,
    };
    var sameTeam = {
      back1: parseFloat(odds_[0]?.back1),
      back2: parseFloat(odds_[0]?.back2),
      back3: parseFloat(odds_[0]?.back3),
      backSize1: parseFloat(odds_[0]?.backSize1),
      backSize2: parseFloat(odds_[0]?.backSize2),
      backSize3: parseFloat(odds_[0]?.backSize3),
      lay1: parseFloat(odds_[0]?.lay1),
      lay2: parseFloat(odds_[0]?.lay2),
      lay3: parseFloat(odds_[0]?.lay3),
      laySize1: parseFloat(odds_[0]?.laySize1),
      laySize2: parseFloat(odds_[0]?.laySize2),
      laySize3: parseFloat(odds_[0]?.laySize3),
      exposure: odds_[0]?.exposure,
      runnerName: odds_[0]?.runnerName,
    };
    var calculationMap = {
      pandl: -Infinity,
      amount: 0,
      oddDecided: 0,
      type: "back",
      oddRate: 0,
    };
    function calculatePandL(oddType, OddSize) {
      if (oddType == "back1" || oddType == "back2" || oddType == "back3") {
        var pandlInternal =
          (oppositeTeam.exposure +
            oppositeTeam[oddType] * sameTeam.exposure -
            sameTeam.exposure) /
          oppositeTeam.oddType;
        var amountInternal = sameTeam.exposure - pandlInternal;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = oppositeTeam[oddType];
          calculationMap.type = "back";
          calculationMap.oddRate = oppositeTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      } else {
        var pandlInternal =
          (sameTeam.exposure +
            sameTeam[oddType] * oppositeTeam.exposure -
            oppositeTeam.exposure) /
          sameTeam[oddType];
        var amountInternal = pandlInternal - oppositeTeam.exposure;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = sameTeam[oddType];
          calculationMap.type = "lay";
          calculationMap.oddRate = sameTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      }
    }

    if (
      sameTeam?.back2 == 0 ||
      sameTeam?.lay2 == 0 ||
      sameTeam?.back3 == 0 ||
      (sameTeam?.lay3 == 0 && oppositeTeam?.back2 == 0) ||
      oppositeTeam?.lay2 == 0 ||
      oppositeTeam?.back3 == 0 ||
      oppositeTeam?.lay3 == 0
    ) {
      calculatePandL("back1", "backSize1");
      calculatePandL("lay1", "laySize1");
    } else {
      calculatePandL("back1", "backSize1");
      calculatePandL("back2", "backSize2");
      calculatePandL("back3", "backSize3");
      calculatePandL("lay1", "laySize1");
      calculatePandL("lay2", "laySize2");
      calculatePandL("lay3", "laySize3");
    }

    if (calculationMap.pandl == -Infinity) {
      toast.error("You are not eligible for cashout");
      return;
    } else if (calculationMap.pandl == Infinity) {
      toast.success("You are not eligible for cashout");
      return;
    }

    setSelectedEventForBet(
      {
        selectedOdd: calculationMap.oddDecided,
        selectedRate: calculationMap.oddRate,
        amount: parseFloat(calculationMap.amount).toFixed(2),
        isBookmaker: false,
        eventId: id,
        marketId: marketIdExternal,
        runnerName: calculationMap.runnerName,
        selectedId: odds_[0]?.selectionId,
        marketName:
          game == "cricket"
            ? marketType == "bookMakerOdds"
              ? marketData?.marketName
              : marketData?.marketName
            : marketData?.marketName,
        marketType,
        sports,
        isCashout: true,
        type: calculationMap.type,
      },
      true
    );
  };
  useEffect(() => {
    let exposure_;
    gameSettings?.plExposureResponseDTOs?.map((item) =>
      item?.runnerPlExposureDTOS?.map((event) => {
        if (isBookmaker) {
          if (
            event?.selectionId == match?.selectionId &&
            item?.marketIdExternal == data?.marketId
          ) {
            exposure_ = event;
          }
        } else {
          if (
            event?.selectionId == match?.selectionId &&
            item?.marketIdExternal == data?.marketId
          ) {
            exposure_ = event;
          }
        }
      })
    );
    setExposure(exposure_);
  }, [gameSettings?.plExposureResponseDTOs]);
  const setSelectedEventForBet = (data) => {
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: data,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getOdds();
    getGameEventDetails();
    setIsLoading(false);
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    let interval = setInterval(() => {
      getEventExposureAndSettings();
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (selectedEventForBet?.amount) {
      setSelectedEventForBet({
        ...selectedEventForBet,
        profit: getProfit(0, game, selectedEventForBet).profit,
        loss: getProfit(0, game, selectedEventForBet).loss,
      });
    }
  }, [selectedEventForBet?.amount]);
  const getPandL = (data, match) => {
    let pandl = null;
    if (data.selectionId == selectedEventForBet?.selectedId) {
      if (selectedEventForBet?.type == "back") {
        pandl =
          parseInt(selectedEventForBet?.profit) +
          (parseInt(exposure?.exposure) ? exposure.exposure : 0);
      } else {
        pandl =
          (parseInt(exposure?.exposure) ? exposure.exposure : 0) -
          parseInt(selectedEventForBet?.loss);
      }
    }
    if (data.selectionId != selectedEventForBet?.selectedId) {
      if (selectedEventForBet?.type == "lay") {
        pandl =
          parseInt(selectedEventForBet?.profit) +
          (parseInt(exposure?.exposure) ? exposure.exposure : 0);
      } else {
        pandl =
          (parseInt(exposure?.exposure) ? exposure.exposure : 0) -
          parseInt(selectedEventForBet?.loss);
      }
    }
    if (pandl == null || pandl == undefined) {
      return "";
    } else if (isNaN(pandl)) {
      return "";
    } else {
      return pandl?.toFixed(2);
    }
  };
  const bookmakerSetBet = (data, type, market, gameType = "bookmaker") => {
    let matchData;

    if (gameType == "match") {
      matchData = odds?.matchOddsResponseDTO[0];
    } else {
      matchData = odds?.other_market_odds?.find((i) => i?.marketId == gameType);
    }
    if (!matchData) return;

    let selectedEventForBet_ = {
      eventId: id,
      amount: 0,
      marketId: matchData?.marketId,
      marketType: gameType != "match" ? market : matchData?.marketName,

      marketName:
        gameType != "match" ? matchData?.market : matchData?.marketName,
      type: type?.startsWith("lay") ? "lay" : "back",
      isBookmaker: gameType == "bookmaker",
      selectedRate: data[type?.startsWith("lay") ? "laySize1" : "backSize1"],
      selectedOdd: data[type],
      selectedId: data.selectionId,

      amount: 0,
      runnerName: data.runnerName,
      isYesAndNo: false,
      matchData: matchData,
    };
    console.log(selectedEventForBet_);

    if (selectedEventForBet_?.selectedOdd == 0) {
      return;
    }

    selectedEventForBet_ = {
      ...selectedEventForBet_,
      profit: getProfit(0, game, selectedEventForBet_).profit,
      loss: getProfit(0, game, selectedEventForBet_).loss,
    };
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: selectedEventForBet_,
    });
  };
  const placeBet = async () => {
    if (!userData?.token) {
      toast.error("Please Login");
      return;
    }
    setIsLoading(true);
    let delay = 0;
    let selectedAmount_ = selectedEventForBet?.amount;
    if (selectedEventForBet.selectedOdd <= 0) {
      toast.error("Please select a Valid Odd");
      setIsLoading(false);
      return;
    }
    if (game == "cricket" || game == "tennis" || game == "soccer") {
      if (
        (selectedEventForBet.marketName == "MATCH_ODDS" &&
          gameSettings?.minStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "BOOKMAKER_ODDS_2" &&
          gameSettings?.minStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS" &&
          gameSettings?.sessionMinStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS_2" &&
          gameSettings?.sessionMinStack > selectedAmount_)
      ) {
        toast.error(
          `Minimum bet amount is ${
            selectedEventForBet.marketName == "FANCY_ODDS_2"
              ? gameSettings?.sessionMinStack
              : selectedEventForBet.marketName == "FANCY_ODDS"
              ? gameSettings?.sessionMinStack
              : selectedEventForBet.marketName == "BOOKMAKER_ODDS_2"
              ? gameSettings?.bookmakerMinStack
              : gameSettings?.minStack
          }`
        );
        setIsLoading(false);
        return;
      }
      if (
        (selectedEventForBet.marketName == "MATCH_ODDS" &&
          gameSettings?.maxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "BOOKMAKER_ODDS_2" &&
          gameSettings?.bookmakerMaxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS" &&
          gameSettings?.sessionMaxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS_2" &&
          gameSettings?.sessionMaxStack < selectedAmount_)
      ) {
        toast.error(
          `Maximum bet amount is ${
            selectedEventForBet.marketName == "FANCY_ODDS_2"
              ? gameSettings?.sessionMaxStack
              : selectedEventForBet.marketName == "FANCY_ODDS"
              ? gameSettings?.sessionMaxStack
              : selectedEventForBet.marketName == "BOOKMAKER_ODDS_2"
              ? gameSettings?.bookmakerMaxStack
              : gameSettings?.maxStack
          }`
        );
        setIsLoading(false);
        return;
      }
    }

    let profit;
    let loss;
    if (game == "tennis" || game == "soccer") {
      profit = casinoPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).profit;
      loss = casinoPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).loss;
    }
    let payload = {
      amount: selectedAmount_,
      profit: parseFloat(profit).toFixed(2),
      loss: parseFloat(loss).toFixed(2),
      marketId: selectedEventForBet.marketId,
      selectionId: selectedEventForBet.selectedId,
      type: selectedEventForBet.type,
      eventId: parseInt(selectedEventForBet.eventId),
      runnerName: selectedEventForBet.runnerName,
      gameType:
        selectedEventForBet.marketName != "MATCH_ODDS" ||
        selectedEventForBet.marketName != "BOOKMAKER_ODDS_1" ||
        selectedEventForBet.marketName != "BOOKMAKER_ODDS_2"
          ? selectedEventForBet.gameType
            ? selectedEventForBet.gameType
            : selectedEventForBet.marketId
          : selectedEventForBet.marketName,
      marketName:
        selectedEventForBet.marketName == "OTHER_MARKET"
          ? selectedEventForBet.marketId
          : selectedEventForBet.marketName,
    };
    if (selectedEventForBet.isBookmaker && selectedEventForBet?.layRate) {
      payload["layRate"] = selectedEventForBet.selectedOdd;
    } else if (
      selectedEventForBet?.isBookmaker &&
      selectedEventForBet?.backRate
    ) {
      payload["backRate"] = selectedEventForBet.selectedOdd;
    }

    if (selectedEventForBet.type == "back") {
      payload["back"] = parseFloat(selectedEventForBet.selectedOdd);
      payload["backRate"] = parseFloat(selectedEventForBet.selectedOdd);
    } else {
      payload["layRate"] = parseFloat(selectedEventForBet.selectedOdd);
      payload["lay"] = parseFloat(selectedEventForBet.selectedOdd);
    }

    await new Promise((resolve) => setTimeout(resolve, delay));

    if (game == "soccer") {
      const { response, code, data } = await placeSoccerBetAPI(
        payload,
        userData.token
      );
      if (code == 200) {
        toast.success("Bet Placed");
        await getEventExposureAndSettings();
      } else if (code == 500) {
        toast.error(response);
      } else if (code == "ERR_BAD_RESPONSE") {
        toast.error("Something Went Wrong");
      } else {
        toast.error("Something Went Wrong");
      }
    }
    setIsLoading(false);
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: null,
    });
  };
  useEffect(() => {
    setIsLoading(true);
    getEventExposureAndSettings();
    setIsLoading(false);
  }, [gameEvent?.eventId]);
  return (
    <app-market-details
      style={{
        display: "block",
        paddingBottom: "100px",
      }}
      _nghost-ng-c1546520345=""
    >
      {loading && <Loader />}

      {/**/}
      <div
        _ngcontent-ng-c1546520345=""
        className="card-body p-0 mb-1 mobile-stream time"
      >
        <div _ngcontent-ng-c1546520345="" className="game-highlight-wrap">
          <span
            _ngcontent-ng-c1546520345=""
            className="cric-txt ng-star-inserted"
          >
            Soccer
          </span>

          <span
            onClick={() => setShowTv(!showTv)}
            _ngcontent-ng-c1546520345=""
            _ngcontent-dsh-c3=""
            style={{
              float: "right",
              fontWeight: "bold",
              marginRight: 16,
              fontSize: 16,
            }}
          >
            <i
              _ngcontent-ng-c1546520345=""
              _ngcontent-dsh-c3=""
              className="fa fa-television"
            />
          </span>
          <span
            onClick={() => setShowScore(!showScore)}
            _ngcontent-ng-c1546520345=""
            _ngcontent-dsh-c3=""
            style={{
              float: "right",
              fontWeight: "bold",
              marginRight: 16,
              fontSize: 16,
            }}
          >
            <i
              _ngcontent-ng-c1546520345=""
              _ngcontent-dsh-c3=""
              className="fa fa-trophy"
            />
          </span>
        </div>
        {showScore && (
          <CustomScoreCard eventId={gameEvent?.eventId} />
        )}
        {showTv ? (
          <>
            <iframe
              style={{
                width: "100%",
                height: "216px",
                marginBottom: -5,
              }}
              src={`https://video.proexch.in/tv/v4/stream/${gameEvent?.eventId || id}`}
            />
          </>
        ) : (
          <div
            _ngcontent-ng-c1546520345=""
            className="container-main-time time-soccer-banner"
          >
            <div
              _ngcontent-ng-c1546520345=""
              className="d-flex flex-column justify-content-between align-items-center p-3 pt-2"
              style={{ height: 100 }}
            >
              <div
                _ngcontent-ng-c1546520345=""
                className="d-flex justify-content-between w-100"
              >
                <div _ngcontent-ng-c1546520345="" className="gameStatus">
                  {" "}
                  OPEN{" "}
                </div>
                <div _ngcontent-ng-c1546520345="" className="gameRemainingTime">
                  <span
                    _ngcontent-ng-c1546520345=""
                    className="betStart"
                    style={{ color: "#ff5" }}
                  >
                    {" "}
                    Game time{" "}
                  </span>{" "}
                  {moment(gameEvent?.eventDate + "Z").format(
                    "DD-MM-YYYY hh:mm A"
                  )}
                </div>
              </div>
              <div
                _ngcontent-ng-c1546520345=""
                className="d-flex justify-content-center align-items-center flex-column"
              >
                {/**/}
                {/**/}
                {/**/}
                {/**/}
                <span
                  _ngcontent-ng-c1546520345=""
                  className="betStart in_play_betStarted"
                  style={{ color: "rgb(255, 255, 255)", fontWeight: "bold" }}
                >
                  {" "}
                  Bet Started{" "}
                </span>
                {/**/}
              </div>
              {/**/}
              {/**/}
            </div>
          </div>
        )}
        {/**/}
        {/**/}
      </div>
      {/**/}
      <div _ngcontent-ng-c1546520345="" className="desktopView">
        {/**/}
      </div>
      {/*  <iframe src="https://score.proexch.in/#/score1/28947946"/> */}
      <div _ngcontent-ng-c1546520345="" className="marketDetailsList-con">
        <ul _ngcontent-ng-c1546520345="" className="marketDetailsList">
          <li _ngcontent-ng-c1546520345="" className="marketDetailsListItem">
            <a
              onClick={() => setSelectedMarket("All")}
              _ngcontent-ng-c1546520345=""
              className={selectedMarket?.toLowerCase() == "all" && "active"}
            >
              All
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Popular")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={selectedMarket?.toLowerCase() == "popular" && "active"}
            >
              Popular
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Matchodds")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem menu-item"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={
                selectedMarket?.toLowerCase() == "matchodds" && "active"
              }
            >
              Match Odds
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Bookmaker")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem menu-item"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={
                selectedMarket?.toLowerCase() == "bookmaker" && "active"
              }
            >
              Bookmaker
            </a>
          </li>
          {/**/}
        </ul>
      </div>
      <div _ngcontent-ng-c1546520345="">
        {odds &&
          odds.matchOddsResponseDTO &&
          odds.matchOddsResponseDTO.length > 0 && (
            <div
              _ngcontent-ng-c1546520345=""
              className="card matchodd matchodd-cont"
            >
              <div
                _ngcontent-ng-c1546520345=""
                className="card-matchodds outer-divs"
              >
                <strong
                  _ngcontent-ng-c1546520345=""
                  className="match-odds outer-div1"
                >
                  Match Odds{" "}
                  <span
                    _ngcontent-ng-c1546520345=""
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal1"
                    className="marketinfo ml-2"
                  >
                    <svg
                      _ngcontent-ng-c1546520345=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      height={15}
                      viewBox="0 0 15 15"
                    >
                      <path
                        _ngcontent-ng-c1546520345=""
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                      />
                    </svg>
                  </span>
                </strong>

                {selectedEventForBet &&
                selectedEventForBet?.isCashout &&
                selectedEventForBet?.marketName ==
                  odds?.matchOddsResponseDTO[0]?.marketName ? (
                  <div
                    _ngcontent-ng-c1546520345=""
                    style={{
                      top: 0,
                    }}
                    className="cashout-container active 40202492993521867 hasProfitLoss ng-star-inserted"
                  >
                    {/**/}
                    <span
                      _ngcontent-ng-c1546520345=""
                      className="cashout-label ng-star-inserted"
                    >
                      <span
                        onClick={() => {
                          placeBet();
                        }}
                        _ngcontent-ng-c1546520345=""
                        className="cashout-icon me-1"
                      >
                        <i
                          _ngcontent-ng-c1546520345=""
                          className="fa fa-check"
                        />
                      </span>
                      <strong
                        _ngcontent-ng-c1546520345=""
                        style={{
                          display: "inline-block",
                          paddingRight: 9,
                        }}
                        className={
                          selectedEventForBet?.profit > 0
                            ? "plus-book"
                            : "minus-book"
                        }
                      >
                        {" "}
                        {selectedEventForBet?.profit}
                      </strong>
                    </span>
                    {/**/}
                  </div>
                ) : (
                  <div
                    _ngcontent-ng-c1546520345=""
                    className="cashout-container outer-div2"
                  >
                    <div
                      onClick={() => {
                        handleCashoutClick(
                          odds?.matchOddsResponseDTO[0]?.marketId,
                          "matchOdds",
                          "soccer"
                        );
                      }}
                      _ngcontent-ng-c1546520345=""
                      className="cashout-container empty-container ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        className="cashout-label"
                      >
                        <span
                          _ngcontent-ng-c1546520345=""
                          className="cashout-icon"
                        >
                          <i
                            _ngcontent-ng-c1546520345=""
                            className="fa fa-circle"
                          />
                        </span>
                        Cash Out
                      </span>
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                  </div>
                )}
                <span
                  _ngcontent-ng-c1546520345=""
                  className="matched-count pull-right outer-div4"
                >
                  Matched <strong _ngcontent-ng-c1546520345="">€ 28.9M</strong>
                </span>
                {/**/}
                {/**/}
              </div>
              <div _ngcontent-ng-c1546520345="" className="card-body p-0">
                <div
                  _ngcontent-ng-c1546520345=""
                  className="table-responsive position-relative"
                >
                  {odds?.matchOddsResponseDTO[0]?.marketStatus?.toUpperCase() !=
                    "OPEN" && (
                    <div
                      _ngcontent-ng-c1546520345=""
                      class="suspended unitycss-PipEJ ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        _ngcontent-wdd-c3=""
                        class="stats-text"
                      >
                        {odds?.matchOddsResponseDTO[0]?.marketStatus?.toUpperCase()}{" "}
                      </span>
                    </div>
                  )}
                  <table
                    _ngcontent-ng-c1546520345=""
                    className="table table-hover tbl-bets betfair-tbl p-rltv"
                  >
                    <thead _ngcontent-ng-c1546520345="">
                      <tr>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="showMinMaxMobile show-xs min-max-mobile"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {eventExposureAndSettings?.minStack} -{" "}
                              {eventExposureAndSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={3}
                          className="hidden-xs boxHide"
                        />
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="back-1 mobileTableHead"
                        >
                          Back
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="lay-1 mobileTableHead"
                        >
                          Lay
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={2}
                          className="min-max-bet boxHide"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {eventExposureAndSettings?.minStack} -{" "}
                              {eventExposureAndSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                      </tr>
                    </thead>
                    <tbody _ngcontent-ng-c1546520345="">
                      {odds &&
                        odds.matchOddsResponseDTO &&
                        odds.matchOddsResponseDTO.length > 0 &&
                        odds?.matchOddsResponseDTO[0]?.oddDetailsDTOS?.map(
                          (item) => (
                            <>
                              {" "}
                              <tr
                                _ngcontent-ng-c1546520345=""
                                className="odd-row "
                                style={{ position: "relative" }}
                              >
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className="team-name"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="title matchodds_runner"
                                  >
                                    {" "}
                                    {item?.runnerName}{" "}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="d-flex"
                                  >
                                    <span
                                      style={{
                                        display:
                                          eventExposureAndSettings?.plExposureResponseDTOs
                                            ?.find(
                                              (i) =>
                                                i.marketIdExternal ===
                                                odds?.matchOddsResponseDTO[0]
                                                  ?.marketId
                                            )
                                            ?.runnerPlExposureDTOS?.find(
                                              (runner) =>
                                                runner.selectionId ==
                                                item.selectionId
                                            )?.exposure == undefined
                                            ? "none !important"
                                            : "flex",
                                      }}
                                      _ngcontent-ng-c1703479958=""
                                      className={` ${
                                        eventExposureAndSettings?.plExposureResponseDTOs
                                          ?.find(
                                            (i) =>
                                              i.marketIdExternal ===
                                              odds?.matchOddsResponseDTO[0]
                                                ?.marketId
                                          )
                                          ?.runnerPlExposureDTOS?.find(
                                            (runner) =>
                                              runner.selectionId ==
                                              item.selectionId
                                          )?.exposure < 0
                                          ? "minus-book"
                                          : "plus-book"
                                      } ng-star-inserted`}
                                    >
                                      {eventExposureAndSettings?.plExposureResponseDTOs
                                        ?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            odds?.matchOddsResponseDTO[0]
                                              ?.marketId
                                        )
                                        ?.runnerPlExposureDTOS?.find(
                                          (runner) =>
                                            runner.selectionId ==
                                            item.selectionId
                                        )?.exposure != undefined && (
                                        <i
                                          _ngcontent-ng-c1703479958=""
                                          className="fa fa-arrow-right right-arrow-mt"
                                        />
                                      )}{" "}
                                      &nbsp;{" "}
                                      {
                                        eventExposureAndSettings?.plExposureResponseDTOs
                                          ?.find(
                                            (i) =>
                                              i.marketIdExternal ===
                                              odds?.matchOddsResponseDTO[0]
                                                ?.marketId
                                          )
                                          ?.runnerPlExposureDTOS?.find(
                                            (runner) =>
                                              runner.selectionId ==
                                              item.selectionId
                                          )?.exposure
                                      }
                                    </span>
                                    {selectedEventForBet &&
                                      selectedEventForBet.marketName ==
                                        odds?.matchOddsResponseDTO[0]
                                          ?.marketName && (
                                        <span _ngcontent-ng-c1546520345="">
                                          {/**/}
                                          <span
                                            _ngcontent-ng-c1546520345=""
                                            style={{
                                              display: "flex",
                                              padding: 0,
                                            }}
                                            className="ng-star-inserted"
                                          >
                                            <span
                                              _ngcontent-ng-c1546520345=""
                                              className="d-flex plus-book matchodds ng-star-inserted"
                                              style={{ marginRight: 5 }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className={`${
                                                  (eventExposureAndSettings?.plExposureResponseDTOs
                                                    ?.find(
                                                      (i) =>
                                                        i.marketIdExternal ===
                                                        odds
                                                          ?.matchOddsResponseDTO[0]
                                                          ?.marketId
                                                    )
                                                    ?.runnerPlExposureDTOS?.find(
                                                      (runner) =>
                                                        runner.selectionId ==
                                                        item.selectionId
                                                    )?.exposure || 0) +
                                                    parseFloat(getPandL(item)) >
                                                  0
                                                    ? "plus"
                                                    : "minus"
                                                }-book matchodds`}
                                              >
                                                {" "}
                                                &nbsp;(
                                                {(eventExposureAndSettings?.plExposureResponseDTOs
                                                  ?.find(
                                                    (i) =>
                                                      i.marketIdExternal ===
                                                      odds
                                                        ?.matchOddsResponseDTO[0]
                                                        ?.marketId
                                                  )
                                                  ?.runnerPlExposureDTOS?.find(
                                                    (runner) =>
                                                      runner.selectionId ==
                                                      item.selectionId
                                                  )?.exposure || 0) +
                                                  parseFloat(getPandL(item))}
                                                )
                                              </span>
                                            </span>
                                            {/**/}
                                            {/**/}
                                          </span>
                                          {/**/}
                                        </span>
                                      )}
                                  </span>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-3 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back1
                                      ? "active"
                                      : ""
                                  } `}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back1",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back1}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize1}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-2 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back2
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back2",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back2}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize2}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-1 count ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back3
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back3",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back3}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize3}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-1 count ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay1
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="lay"
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay1",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay1}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize1}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-2 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay2
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay2",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="lay"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay2}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize2}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-3 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay3
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="lay"
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay3",
                                        item?.marketName,
                                        "match"
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay3}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize3}
                                    </span>
                                  </a>
                                </td>
                              </tr>
                              {selectedEventForBet &&
                                selectedEventForBet.selectedId ==
                                  item?.selectionId && (
                                  <BetSlip
                                    selectedEventForBet={selectedEventForBet}
                                    placeBet={placeBet}
                                    setSelectedEventForBet={
                                      setSelectedEventForBet
                                    }
                                    dispatch={dispatch}
                                  />
                                )}
                            </>
                          )
                        )}

                      {/**/}
                      {/**/}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        {selectedMarket?.toLowerCase() == "all" &&
          odds &&
          odds?.other_market_odds &&
          odds?.other_market_odds.length > 0 &&
          odds?.other_market_odds
            ?.sort((a, b) => a.marketId - b?.marketId)
            .map((market) => (
              <div
                _ngcontent-ng-c1546520345=""
                className="card matchodd matchodd-cont"
              >
                <div
                  _ngcontent-ng-c1546520345=""
                  className="card-matchodds outer-divs"
                >
                  <strong
                    _ngcontent-ng-c1546520345=""
                    className="match-odds outer-div1"
                  >
                    {market?.market}{" "}
                    <span
                      _ngcontent-ng-c1546520345=""
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal1"
                      className="marketinfo ml-2"
                    >
                      <svg
                        _ngcontent-ng-c1546520345=""
                        xmlns="http://www.w3.org/2000/svg"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                      >
                        <path
                          _ngcontent-ng-c1546520345=""
                          fill="currentColor"
                          fillRule="evenodd"
                          d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                        />
                      </svg>
                    </span>
                  </strong>
                  {selectedEventForBet &&
                  selectedEventForBet?.isCashout &&
                  selectedEventForBet?.marketName == market?.marketName &&
                  selectedEventForBet?.marketId == market?.marketId ? (
                    <div
                      _ngcontent-ng-c1546520345=""
                      style={{
                        top: 0,
                      }}
                      className="cashout-container active 40202492993521867 hasProfitLoss ng-star-inserted"
                    >
                      {/**/}
                      <span
                        _ngcontent-ng-c1546520345=""
                        className="cashout-label ng-star-inserted"
                      >
                        <span
                          onClick={() => {
                            placeBet();
                          }}
                          _ngcontent-ng-c1546520345=""
                          className="cashout-icon me-1"
                        >
                          <i
                            _ngcontent-ng-c1546520345=""
                            className="fa fa-check"
                          />
                        </span>
                        <strong
                          _ngcontent-ng-c1546520345=""
                          style={{
                            display: "inline-block",
                            paddingRight: 9,
                            fontSize: 11,
                          }}
                          className={
                            selectedEventForBet?.profit > 0
                              ? "plus-book"
                              : "minus-book"
                          }
                        >
                          {" "}
                          {selectedEventForBet?.profit}
                        </strong>
                      </span>
                      {/**/}
                    </div>
                  ) : (
                    <div
                      _ngcontent-ng-c1546520345=""
                      className="cashout-container outer-div2"
                    >
                      <div
                        onClick={() => {
                          handleCashoutClick(
                            market?.marketId,
                            "other_market_odds",
                            "soccer"
                          );
                        }}
                        _ngcontent-ng-c1546520345=""
                        className="cashout-container empty-container ng-star-inserted"
                      >
                        <span
                          _ngcontent-ng-c1546520345=""
                          className="cashout-label"
                        >
                          <span
                            _ngcontent-ng-c1546520345=""
                            className="cashout-icon"
                          >
                            <i
                              _ngcontent-ng-c1546520345=""
                              className="fa fa-circle"
                            />
                          </span>
                          Cash Out
                        </span>
                      </div>
                      {/**/}
                      {/**/}
                      {/**/}
                    </div>
                  )}
                  <span
                    _ngcontent-ng-c1546520345=""
                    className="matched-count pull-right outer-div4"
                  >
                    Matched{" "}
                    <strong _ngcontent-ng-c1546520345="">€ 28.9M</strong>
                  </span>
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-ng-c1546520345="" className="card-body p-0">
                  <div
                    _ngcontent-ng-c1546520345=""
                    className="table-responsive position-relative"
                  >
                    {market?.marketStatus?.toUpperCase() != "OPEN" && (
                      <div
                        _ngcontent-ng-c1546520345=""
                        class="suspended unitycss-PipEJ ng-star-inserted"
                      >
                        <span
                          _ngcontent-ng-c1546520345=""
                          _ngcontent-wdd-c3=""
                          class="stats-text"
                        >
                          {market?.marketStatus?.toUpperCase()}{" "}
                        </span>
                      </div>
                    )}
                    <table
                      _ngcontent-ng-c1546520345=""
                      className="table table-hover tbl-bets betfair-tbl p-rltv"
                    >
                      <thead _ngcontent-ng-c1546520345="">
                        <tr>
                          <th
                            _ngcontent-ng-c1546520345=""
                            className="showMinMaxMobile show-xs min-max-mobile"
                          >
                            <dl
                              _ngcontent-ng-c1546520345=""
                              id="minMaxBox"
                              className="fancy-info matchoddsminmax"
                            >
                              <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                              <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                                {market?.min} - {market?.max}
                              </dd>
                            </dl>
                          </th>
                          <th
                            _ngcontent-ng-c1546520345=""
                            colSpan={3}
                            className="hidden-xs boxHide"
                          />
                          <th
                            _ngcontent-ng-c1546520345=""
                            className="back-1 mobileTableHead"
                          >
                            Back
                          </th>
                          <th
                            _ngcontent-ng-c1546520345=""
                            className="lay-1 mobileTableHead"
                          >
                            Lay
                          </th>
                          <th
                            _ngcontent-ng-c1546520345=""
                            colSpan={2}
                            className="min-max-bet boxHide"
                          >
                            <dl
                              _ngcontent-ng-c1546520345=""
                              id="minMaxBox"
                              className="fancy-info matchoddsminmax"
                            >
                              <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                              <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                                {market?.min} - {market?.max}
                              </dd>
                            </dl>
                          </th>
                        </tr>
                      </thead>
                      <tbody _ngcontent-ng-c1546520345="">
                        {odds &&
                          odds.other_market_odds &&
                          odds.other_market_odds.length > 0 &&
                          market?.oddDetailsDTOS?.map((item) => (
                            <>
                              {" "}
                              <tr
                                _ngcontent-ng-c1546520345=""
                                className="odd-row "
                                style={{ position: "relative" }}
                              >
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className="team-name"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="title matchodds_runner"
                                  >
                                    {" "}
                                    {item?.runnerName}{" "}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="d-flex"
                                  >
                                    <span
                                      style={{
                                        display:
                                          eventExposureAndSettings?.plExposureResponseDTOs
                                            ?.find(
                                              (i) =>
                                                i.marketIdExternal ===
                                                market?.marketId
                                            )
                                            ?.runnerPlExposureDTOS?.find(
                                              (runner) =>
                                                runner.selectionId ==
                                                item.selectionId
                                            )?.exposure == undefined
                                            ? "none !important"
                                            : "flex",
                                      }}
                                      _ngcontent-ng-c1703479958=""
                                      className={` ${
                                        eventExposureAndSettings?.plExposureResponseDTOs
                                          ?.find(
                                            (i) =>
                                              i.marketIdExternal ===
                                              market?.marketId
                                          )
                                          ?.runnerPlExposureDTOS?.find(
                                            (runner) =>
                                              runner.selectionId ==
                                              item.selectionId
                                          )?.exposure < 0
                                          ? "minus-book"
                                          : "plus-book"
                                      } ng-star-inserted`}
                                    >
                                      {eventExposureAndSettings?.plExposureResponseDTOs
                                        ?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            market?.marketId
                                        )
                                        ?.runnerPlExposureDTOS?.find(
                                          (runner) =>
                                            runner.selectionId ==
                                            item.selectionId
                                        )?.exposure != undefined && (
                                        <i
                                          _ngcontent-ng-c1703479958=""
                                          className="fa fa-arrow-right right-arrow-mt"
                                        />
                                      )}{" "}
                                      &nbsp;{" "}
                                      {
                                        eventExposureAndSettings?.plExposureResponseDTOs
                                          ?.find(
                                            (i) =>
                                              i.marketIdExternal ===
                                              market?.marketId
                                          )
                                          ?.runnerPlExposureDTOS?.find(
                                            (runner) =>
                                              runner.selectionId ==
                                              item.selectionId
                                          )?.exposure
                                      }
                                    </span>
                                    {selectedEventForBet &&
                                      selectedEventForBet?.marketId ==
                                        market?.marketId &&
                                      selectedEventForBet.marketName ==
                                        market?.marketName && (
                                        <span _ngcontent-ng-c1546520345="">
                                          {/**/}
                                          <span
                                            _ngcontent-ng-c1546520345=""
                                            style={{
                                              display: "flex",
                                              padding: 0,
                                            }}
                                            className="ng-star-inserted"
                                          >
                                            <span
                                              _ngcontent-ng-c1546520345=""
                                              className="d-flex plus-book matchodds ng-star-inserted"
                                              style={{ marginRight: 5 }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className={`${
                                                  getPandL(item) > 0
                                                    ? "plus"
                                                    : "minus"
                                                }-book matchodds`}
                                              >
                                                {" "}
                                                &nbsp;({getPandL(item)})
                                              </span>
                                            </span>
                                            {/**/}
                                            {/**/}
                                          </span>
                                          {/**/}
                                        </span>
                                      )}
                                  </span>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-3 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back3
                                      ? "active"
                                      : ""
                                  } `}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back3",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back3}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize3}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-2 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back2
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back2",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back2}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize2}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`back-1 count ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "back" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.back1
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "back1",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="back"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.back1}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.backSize1}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-1 count ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay1
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className={`lay`}
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay1",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-book-inner-data match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay1}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize1}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-2 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay2
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay2",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="lay"
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay2}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize2}
                                    </span>
                                  </a>
                                </td>
                                <td
                                  _ngcontent-ng-c1546520345=""
                                  className={`lay-3 count boxHide ${
                                    selectedEventForBet &&
                                    selectedEventForBet.type == "lay" &&
                                    selectedEventForBet.selectedId ==
                                      item?.selectionId &&
                                    selectedEventForBet.selectedOdd ==
                                      item?.lay3
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    _ngcontent-ng-c1546520345=""
                                    appratehighlighter=""
                                    className="lay"
                                    onClick={() => {
                                      bookmakerSetBet(
                                        item,
                                        "lay3",
                                        market?.market,
                                        market?.marketId
                                      );
                                    }}
                                  >
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-top"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {item?.lay3}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1546520345=""
                                      className="position-relative match-inn-txt-btm"
                                    >
                                      {item?.laySize3}
                                    </span>
                                  </a>
                                </td>
                              </tr>
                              {selectedEventForBet &&
                                selectedEventForBet.selectedId ==
                                  item?.selectionId && (
                                  <BetSlip
                                    selectedEventForBet={selectedEventForBet}
                                    placeBet={placeBet}
                                    setSelectedEventForBet={
                                      setSelectedEventForBet
                                    }
                                    dispatch={dispatch}
                                  />
                                )}
                            </>
                          ))}

                        {/**/}
                        {/**/}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {/**/}
      {modalContent && (
        <Modal content={modalContent} setShowModal={setModalContent} />
      )}
    </app-market-details>
  );
}
